// CAPSNA Mock Data

export const heroContent = {
  title: "Kurumsal Doküman Yönetiminde",
  highlight: "Yeni Nesil",
  description: "CAPSNA, kurumsal ölçekte doküman yönetimi, yapay zeka destekli analiz ve iş zekası yeteneklerini tek bir modern platformda birleştiren güçlü bir çözümdür.",
  subtext: "Dokümanlarınızı sadece saklamaz; anlayan, yorumlayan ve değer üreten akıllı varlıklara dönüştürür."
};

export const mainFeatures = [
  {
    icon: "FileText",
    title: "Akıllı Doküman Yönetimi",
    description: "PDF, DOCX, TXT, Markdown dosyalarını otomatik işleyin, versiyonları takip edin ve akıllı etiketleme ile organize edin."
  },
  {
    icon: "MessageSquareText",
    title: "Doğal Dil Sorgulama",
    description: "Türkçe veya İngilizce sorularınızla dokümanlarınıza ve veritabanlarınıza anında erişin."
  },
  {
    icon: "BarChart3",
    title: "İş Zekası & Analiz",
    description: "SQL sorgularını doğal dile çevirin, akıllı grafikler oluşturun ve anomali tespiti yapın."
  },
  {
    icon: "Shield",
    title: "Kurumsal Güvenlik",
    description: "RBAC, LDAP/AD entegrasyonu, audit logging ve granüler erişim kontrolü ile tam güvenlik."
  }
];

export const allFeatures = {
  documentManagement: {
    title: "Doküman Yönetimi",
    icon: "FileText",
    color: "blue",
    items: [
      { name: "Çoklu Format Desteği", description: "PDF, DOCX, TXT, Markdown" },
      { name: "Versiyon Kontrolü", description: "Takip, karşılaştırma, geri yükleme" },
      { name: "Akıllı Etiketleme", description: "AI destekli otomatik kategorileme" },
      { name: "Hiyerarşik Klasörler", description: "Ölçeklenebilir organizasyon" },
      { name: "Gelişmiş Arama", description: "İçerik bazlı filtreleme" }
    ]
  },
  aiFeatures: {
    title: "AI Özellikleri",
    icon: "Sparkles",
    color: "violet",
    items: [
      { name: "RAG Soru-Cevap", description: "Doğal dilde doküman sorgulama" },
      { name: "Otomatik Özetleme", description: "Uzun dokümanları özetleme" },
      { name: "Doküman Karşılaştırma", description: "AI ile fark analizi" },
      { name: "Yazım Asistanı", description: "İçerik oluşturma desteği" },
      { name: "Kalite Puanlama", description: "Otomatik değerlendirme" },
      { name: "Plagiarizm Tespiti", description: "Kopya içerik analizi" }
    ]
  },
  sqlBi: {
    title: "SQL & İş Zekası",
    icon: "Database",
    color: "emerald",
    items: [
      { name: "Doğal Dil → SQL", description: "TR/EN otomatik çeviri" },
      { name: "Çoklu Veritabanı", description: "SQL Server, PostgreSQL, MySQL, Oracle" },
      { name: "Akıllı Grafikler", description: "Otomatik görselleştirme" },
      { name: "Anomali Tespiti", description: "AI ile olağandışı durum tespiti" },
      { name: "Trend Analizi", description: "Tahmine dayalı analiz" }
    ]
  },
  collaboration: {
    title: "İşbirliği & Workflow",
    icon: "Users",
    color: "amber",
    items: [
      { name: "Güvenli Paylaşım", description: "Okuma/yazma izinleri" },
      { name: "Onay Süreçleri", description: "Doküman bazlı iş akışları" },
      { name: "Görev Yönetimi", description: "Doküman bağlantılı görevler" },
      { name: "Yorum Sistemi", description: "Tartışma ve geri bildirim" },
      { name: "Bildirimler", description: "Gerçek zamanlı uyarılar" }
    ]
  },
  security: {
    title: "Güvenlik & Yönetim",
    icon: "Lock",
    color: "red",
    items: [
      { name: "RBAC", description: "Rol tabanlı erişim kontrolü" },
      { name: "LDAP / AD", description: "SSO entegrasyonu" },
      { name: "Gizlilik Seviyeleri", description: "Public, Internal, Confidential" },
      { name: "Audit Logging", description: "Detaylı erişim geçmişi" },
      { name: "Veri Maskeleme", description: "Hassas bilgi koruması" }
    ]
  },
  webVideo: {
    title: "Web & Video",
    icon: "Globe",
    color: "cyan",
    items: [
      { name: "Web Scraping", description: "Web sayfalarını kaynak olarak ekleme" },
      { name: "YouTube Entegrasyonu", description: "Video transkript çıkarma" },
      { name: "Kaynak Versiyonlama", description: "İçerik değişiklik takibi" }
    ]
  }
};

export const useCases = [
  {
    id: 1,
    icon: "GraduationCap",
    title: "Akademik Araştırma",
    description: "Literatür taraması, dergi önerisi ve plagiarizm kontrolü",
    highlights: ["Literatür taraması", "Dergi önerisi", "Plagiarizm kontrolü"]
  },
  {
    id: 2,
    icon: "Building2",
    title: "Kurumsal Yönetim",
    description: "Sözleşme yönetimi, onay süreçleri ve güvenli paylaşım",
    highlights: ["Sözleşme yönetimi", "Onay süreçleri", "Versiyon takibi"]
  },
  {
    id: 3,
    icon: "BarChart3",
    title: "İş Zekası",
    description: "Doğal dil sorgu, otomatik rapor ve trend analizi",
    highlights: ["Doğal dil sorgu", "Otomatik rapor", "Anomali tespiti"]
  },
  {
    id: 4,
    icon: "Landmark",
    title: "Kamu & Regülasyon",
    description: "Mevzuat takibi, uyumluluk ve denetim izleri",
    highlights: ["Mevzuat takibi", "Uyumluluk kontrolü", "Audit trail"]
  }
];

export const techStack = [
  { name: "OpenAI", category: "LLM" },
  { name: "Ollama", category: "LLM" },
  { name: "Gemini", category: "LLM" },
  { name: "SQL Server", category: "Database" },
  { name: "PostgreSQL", category: "Database" },
  { name: "MySQL", category: "Database" },
  { name: "Oracle", category: "Database" },
  { name: "SAP HANA", category: "Database" }
];

export const capabilities = [
  { value: "PDF/DOCX/TXT/MD", label: "Doküman Formatları" },
  { value: "6+", label: "Veritabanı Desteği" },
  { value: "3+", label: "LLM Entegrasyonu" },
  { value: "TR/EN", label: "Dil Desteği" }
];
